export default "__VITE_ASSET__d7b9da82__"